import type { CurrencyInfo, VendorRequest } from '@leanpay/models'
import { CurrencySymbols } from '@leanpay/models'

import { Market } from './constants'
import { separateThousands } from './utils'

// Used for SLO, ROM
const LOCALE = 'hr-HR'

export const offerInStoreLabel = (d: VendorRequest): string => (d.inStore ? 'inStore' : 'remote')

export const offerFullName = (d: VendorRequest): string => `${d.firstName} ${d.lastName}`

export const offerVendorUserFullName = (d: VendorRequest): string =>
    `${d.vendorUserName ?? ''} ${d.vendorUserLastName ?? ''}`

export const vendorUserFullName = (
    u: { firstName: string; lastName: string },
    market: Market,
): string =>
    market === Market.HUN ? `${u.lastName} ${u.firstName}` : `${u.firstName} ${u.lastName}`

export const currencySymbol = (c: CurrencyInfo): CurrencySymbols =>
    CurrencySymbols[c.primaryCurrency as 'EUR' | 'lei' | 'Ft']

const formatCurrency = (
    c: CurrencyInfo,
    amount: number,
    separator: string,
    fractionDigits = 2,
): string => {
    const formattedAmount = amount.toLocaleString(LOCALE, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    })
    const symbol = currencySymbol(c)

    if (c.multiCurrency && c.conversionRate && c.secondaryCurrency) {
        const convertedAmount = amount * c.conversionRate

        if (symbol === CurrencySymbols.Ft) {
            return `${amount} ${symbol}${separator}${convertedAmount.toLocaleString()}`
        }

        return `${formattedAmount} ${symbol}${separator}${convertedAmount.toLocaleString(LOCALE, {
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits,
        })} ${c.secondaryCurrency}`
    }

    if (symbol === CurrencySymbols.Ft) {
        return `${separateThousands(amount)} ${symbol}`
    }

    return `${formattedAmount} ${symbol}`
}

export const displayCurrency = (
    c: CurrencyInfo,
    amount?: number,
    options?: { fractionDigits?: number },
): string | undefined => {
    if (amount === undefined) return undefined
    return formatCurrency(c, amount, ' / ', options?.fractionDigits)
}

export const displayCurrencyWithBreakAndHtml = (c: CurrencyInfo, amount: number): string =>
    formatCurrency(c, amount, '<br/>')
